import {
  IconAddressBook,
  IconAdjustmentsHorizontal,
  IconBriefcase,
  IconBuildingBank,
  IconCalendarEvent,
  IconCash,
  IconCreditCard,
  IconCurrencyBitcoin,
  IconDiamond,
  IconFileCertificate,
  IconFileText,
  IconHeartbeat,
  IconHeartHandshake,
  IconHome,
  IconKey,
  IconMessage,
  IconReceipt,
  IconReceiptTax,
  IconShieldCheck,
  IconTarget,
  IconTrendingUp,
  IconUser,
  IconUsers,
  TablerIcon,
} from '@tabler/icons-react';

const ICONS: Record<string, TablerIcon> = {
  DefinedBenefitPension: IconBuildingBank,
  DefinedContributionPension: IconBuildingBank,
  IncomeDrawdownPension: IconBuildingBank,
  PensionAnnuity: IconBuildingBank,
  StatePension: IconBuildingBank,
  InvestmentAndCash: IconTrendingUp,
  SpendingAccount: IconCreditCard,
  Property: IconHome,
  Mortgage: IconKey,
  Loan: IconReceipt,
  Protection: IconShieldCheck,
  Income: IconCash,
  EmploymentInfo: IconBriefcase,
  Occupation: IconBriefcase,
  Expenditure: IconReceipt,
  Objective: IconTarget,
  Health: IconHeartbeat,
  Vulnerability: IconHeartHandshake,
  PersonalDetails: IconUser,
  Dependant: IconUsers,
  EstatePlanning: IconFileCertificate,
  TaxProfile: IconReceiptTax,
  RiskAndInvestmentPreferences: IconAdjustmentsHorizontal,
  LifeEvent: IconCalendarEvent,
  ProfessionalConnection: IconAddressBook,
  Collectible: IconDiamond,
  Crypto: IconCurrencyBitcoin,
  SoftFacts: IconMessage,
};

export const iconFor = (entityType: string): TablerIcon => ICONS[entityType] ?? IconFileText;
